import React, { useEffect, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import Heading from "../blockHeading/heading"
import "./blockExpSig.scss"
import { graphql,Link } from "gatsby"
import Media from "../media"
import HTMLReactParser from "html-react-parser"
import {debounce} from "../../functions"
import "../../../assets/scss/plugins/_slick.scss"
import Slider from "react-slick"


const BlkExpSig = ({ content }) => {

  const breakpoint = 640

  const [screen, setMobile] = useState({
    isMobile: typeof window !== `undefined` && window.innerWidth < breakpoint,
  })

  const [isClient, setClient] = useState(false)

  const gridItems = content.relationships?.block_tiled_experience_items?.map((item, index) => {
    switch (item.internal.type) {
      case "paragraph__tiled_media_item":
        return (
          <div key={index} className={item.tiled_media_item_type === "landscape" ? "grid-wide" : ""}>
            <div className={item.tiled_media_item_title && item.tiled_media_item_description ? "media" : "media noDesc" }>
              <Media media={item.relationships?.tiled_media_item_media} />
            </div>
            {/* Check if there is tiled_media_item_title or tiled_media_item_description */}
            {item.tiled_media_item_title || item.tiled_media_item_description ?
              <div className="grid-text">
                {item.tiled_media_item_title && <h3>{item.tiled_media_item_title}</h3>}
                {
                  item.tiled_media_item_description &&
                  <div className="description">
                    {HTMLReactParser(item.tiled_media_item_description.processed)}
                    {item.tiled_media_item_link && (
                      <Link className="simpleLink" to={item.tiled_media_item_link.url   }>
                        {item.tiled_media_item_link.title}
                      </Link>
                    )}
                  </div>
                }
              </div>
              : <></>}
          </div>
        )
      case "paragraph__tiled_quote_item":
        return (
          <div className="grid-quote">
            {item.tiled_quote_item_description && <div>{HTMLReactParser(item.tiled_quote_item_description.processed)}</div>}
          </div>
        )
      default:
        return (
          <></>
        )
    }
  })

  useEffect(() => {
    setClient(true)

    const debouncedHandleResize = debounce(function handleResize() {
      setMobile({
        isMobile:
            typeof window !== `undefined` && window.innerWidth < breakpoint,
      })
    }, 200)

    if (typeof window !== `undefined`) {
      window.addEventListener("resize", debouncedHandleResize)
    }
  }, [])

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <section className="blk-grid-exp">
      <Container>
        <Row>
          <Col>
            <div className="grid-cont">
              <div className="grid-intro">
                <Heading
                  caption={content.block_tiled_experience_caption}
                  title={content.block_tiled_experience_title}
                  description={content.block_tiled_experience_desc.processed}
                />
              </div>
              {isClient && screen.isMobile ? (
                <>
                  <Slider {...settings}>
                    {gridItems}
                  </Slider>
                </>
            ) : (
                <>
                  {gridItems}
                </>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export const query = graphql`
  fragment tiledExperiences on paragraph__block_tiled_experience {
    block_tiled_experience_title
    block_tiled_experience_desc {
      processed
    }
    block_tiled_experience_caption
    relationships {
      block_tiled_experience_items {
        ... on paragraph__tiled_media_item {
          internal {
            type
          }
          id
          tiled_media_item_type
          tiled_media_item_title
          tiled_media_item_link {
            title
            url
          }
          tiled_media_item_description {
            processed
          }
          relationships {
            tiled_media_item_media {
              ...getImageVideo
            }
          }
        }
        ... on paragraph__tiled_quote_item {
          internal {
            type
          }
          tiled_quote_item_description {
            processed
          }
        }
      }
    }
  }
`

export default BlkExpSig
